// @ts-ignore
export default function (value){
    if(!value || !value.name || !value.lastname) return;
    const name = value.name[0];
    const lastname = value.lastname[0];
    return name+lastname;
}